import React, { useEffect, useState } from 'react';

import { useMemberList } from '@/components/features/casino/crash/PlayerBox/useCrashMember';
import {
  crashedMemberAtom,
  gameStatusState,
} from '@/components/features/casino/crash/state';
import {
  GameStatus,
  ShowGameMemberItem,
} from '@/components/features/casino/crash/types/crash';
import { Box, Typography } from '@mui/material';
import { useAtom, useAtomValue } from 'jotai';
import { AnimatedItem, CrashMemberWrapper } from './styles';
import MoneyWithCurrencyIcon from '@/components/biz/MoneyWithCurrencyIcon';

const CrashMember: React.FC = () => {
  const MAX_MEMBER_NUM = 4;
  const [gameStatus, setGameStatus] = useAtom(gameStatusState);
  const [curList, setCurList] = useState<ShowGameMemberItem[]>([]);
  const crashedMembers = useAtomValue(crashedMemberAtom);
  useEffect(() => {
    if (crashedMembers.length === 0) {
      setCurList([]);
      return;
    }
    setCurList((prev) => {
      const newList = [...prev];
      const set = new Set(newList.map((item) => item.userId));
      const latestElement = crashedMembers[crashedMembers.length - 1];
      // 防止重复添加
      if (set.has(latestElement.userId)) {
        return newList;
      }

      if (newList.length >= MAX_MEMBER_NUM) {
        newList.pop();
      }
      newList.unshift(crashedMembers[crashedMembers.length - 1] as any);
      return newList;
    });
  }, [crashedMembers.length]);

  const opacityMap = [1, 1, 0.8, 0.5];
  if (curList.length === 0) return null;
  if ([GameStatus.InProgress, GameStatus.Crash].includes(gameStatus)) {
    return (
      <CrashMemberWrapper>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
          }}
        >
          {curList.map((item, index) => (
            // @ts-ignore
            <AnimatedItem key={item.userId} opacity={opacityMap[index]}>
              {item.showPlayer}
              <Typography
                sx={{
                  color: (theme) => theme.palette.green['500'],
                  display: 'inline-flex',
                  alignItems: 'center',
                  ml: 0.5,
                }}
                component={'span'}
              >
                <MoneyWithCurrencyIcon
                  value={item.showProfit}
                  currency={item.currency}
                />
              </Typography>
            </AnimatedItem>
          ))}
        </Box>
      </CrashMemberWrapper>
    );
  } else {
    return <></>;
  }
};

export default CrashMember;
